module.exports = __webpack_public_path__ + "static/media/contact.66a86a5b.png";